/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rm_NameInputs */

const en_rm_name = /** @type {(inputs: Rm_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Room`)
};

const id_rm_name = /** @type {(inputs: Rm_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang Rancang`)
};

/**
* | output |
* | --- |
* | "Design Room" |
*
* @param {Rm_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rm_name = /** @type {((inputs?: Rm_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rm_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rm_name(inputs)
	return en_rm_name(inputs)
});